import * as ActionTypes from "./actionTypes";

export function loadTopics(appKey) {
	return { type: ActionTypes.LOAD_TOPICS, appKey };
}

export function loadTopicsSuccess(topics) {
	return { type: ActionTypes.LOAD_TOPICS_SUCCESS, topics };
}
